/*
 * Public API Surface of ui-icons
 */
export * from './lib/ui-icons.module';
export * from './lib/model/ui-icons.model';
export * from './lib/components/icon/icon.component';
export * from './lib/components/sdg-icon/sdg-icon.component';
export * from './lib/tokens/ui-icon-language.token';
